<template>
  <div class="d-flex-100 align-content-start" id="newsletterCol">
    <div class="d-flex justify-content-between align-items-center">
      <div class="db-100 customer-panel-ttl">{{ t('newsletter.form.title') }}</div>
      <i v-if="isSmallScreen" :class="chevronIcon" @click="toggleContentVisibility"></i>
    </div>
    <div v-if="isContentVisible">
      <p class="db-100">{{ t('newsletter.form.text') }}</p>
      <div class="d-flex-100" id="submitForm">
        <input type="text" v-model="email" :placeholder="t('newsletter.email.placeholder')" class="submit-form-input">
        <button v-on:click="formSubmit()" type="button">{{ t('entry.lbl') }}</button>
      </div>
      <div class="d-flex-100">
        <input type="checkbox" id="newsletterCheckBox" class="newsletter-form-footer-checkbox-input" name="newsletterCheckBox" v-model="checkboxCheked" required>
        <label for="newsletterCheckBox" class="newsletter-form-footer-checkbox-label">
          <span class="newsletter-form-footer-checkbox-label-text">
            {{ t('newsletter.checkbox.agree.label') }}
          </span>
        </label>
      </div>
      <div v-if="showError" class="d-flex-100">
        <div class="alert alert-danger">{{ error }}</div>
      </div>
      <div v-if="formPosted" class="d-flex-100">
        <div class="alert alert-success">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NewsletterForm',
  data () {
    return {
      email: '',
      formPosted: false,
      showError: false,
      error: '',
      message: '',
      checkboxCheked: false,
      isContentVisible: true
    }
  },
  computed: {
    chevronIcon () {
      return this.isContentVisible ? 'lni lni-chevron-up' : 'lni lni-chevron-down'
    },
    isSmallScreen () {
      return window.innerWidth <= 500
    }
  },
  methods: {
    toggleContentVisibility () {
      this.isContentVisible = !this.isContentVisible
    },
    formSubmit () {
      if (!this.checkboxCheked) {
        this.error = this.t('newsletter.checkbox.error')
        this.showError = true
        return
      }
      if (!this.validateEmail()) {
        this.error = this.t('newsletter.email.error')
        this.showError = true
        return
      }

      this.postData()
    },
    validateEmail () {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return regex.test(this.email)
    },
    postData () {
      this.formPosted = false
      this.showError = false
      this.error = ''
      this.message = ''

      axios
        .post('/api/customer/addCustomerNewsletter', { email: this.email })
        .then((response) => {
          const { subscribed } = response.data
          this.showError = !subscribed
          if (subscribed) {
            this.formPosted = true
            this.message = this.t('newsletter.subscribe.success')
          } else {
            this.error = this.t('newsletter.subscribe.already.subscribed')
          }
        })
        .catch((error) => {
          this.showError = true
          this.error = error.response?.data?.date || this.t('newsletter.subscribe.error')
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

#newsletterCol{
  padding:30px;
  background: #c4b6c8;
  color:#fff;
  height: 100%;
  position: relative;
  @media (max-width:767px), (min-width:992px) and (max-width:1199px){
    padding:20px;
    background: #c4b6c8;
    margin-top: 1rem;
  }
  .customer-panel-ttl{
    font-size: 27px;
    font-weight: 900;
    @media screen and (min-width:768px) and (max-width:1199px){
      font-size: 27px
    }
    @media screen and (max-width:767px){
      font-size: 17px;
      font-weight: 800
    }
  }
  .customer-panel-ttl, p{
    flex:0 0 72%;
    max-width: 72%;
    line-height: 1.3;
    @media (max-width:767px), (min-width:992px) and (max-width:1199px){
      flex:0 0 100%;
      max-width: 100%
    }
  }
  p{
    line-height: 1.3;
    margin:0 0 15px 0;
    @media screen and (min-width:992px) and (max-width:1199px){
      font-size: 14px
    }
  }
  @media screen and (max-width: 500px) {
    .lni {
      position: absolute;
      top: 20px;
      right: 15px;
      font-size: 20px;
    }
  }
}
#submitForm{
  height:48px;
  input[type="date"]{
    margin-right:15px;
    border:1px solid #000;
    background-color: #fff;
    height:48px;
    flex:0 0 60%;
    max-width:60%;
  }
  [type="date"] {
    background: url(../img/calendar_icon_gray_b_form.webp) calc(100% - 10px) center no-repeat #fff;
    position: relative;
    appearance: none
  }
  // works only on Chrome
  [type="date"]::-webkit-inner-spin-button {
    display: none;
    opacity: 0;
  }
  [type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    display:none
  }
  button{
    background:#000;
    color:#fff;
    border:0;
    padding:0 10px;
    height:48px;
    flex:0 0 35%;
    max-width:35%;
    margin-left:auto;
  }
  @media (max-width:400px), (min-width:992px) and (max-width:1199px){
    input[type="date"]{
      flex:0 0 53%;
      max-width: 53%;
      margin-right:0
    }
    button{
      flex:0 0 47%;
      max-width: 47%;
      font-size:14px
    }
  }
  @media screen and (max-width: 575px) {
    [type="text"] {
      max-width: 160px;
    }
  }
}
// homepage logged in user overrides
.home-info-user-mods-col {
  #newsletterCol{
    @media screen and (min-width:1200px) and (max-width:1399px){
      padding:15px
    }
    #submitForm{
      input[type="date"]{
        margin-right:0
      }
      button{
        flex:0 0 calc(35% + 15px);
        max-width:calc(35% + 15px);
        margin-left:5px;
        @media screen and (max-width:420px){
          flex: 0 0 calc(30% + 15px);
          max-width: calc(30% + 15px);
          font-size: 12px;
        }
      }
    }
  }
}
.submit-form-input {
  @media screen and (max-width:420px){
    font-size: 13px;
  }
}
.alert-warning {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #fff;
}
.newsletter-form-footer-checkbox-label-text{
  margin-left: 5px;
  @media screen and (max-width:420px){
    font-size: 13px;
  }
}
</style>
